import { OnChanges, SimpleChanges, Directive } from '@angular/core';

@Directive()
export class ChangeDependentValidator implements OnChanges {
  inputNames: string[] = null;

  onChange: () => void;

  constructor(name: string[]) {
    this.inputNames = name;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.inputNames.some(name => name in changes)) {
      if (this.onChange) {
        this.onChange();
      }
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}